export default __webpack_public_path__ + "static/media/Urad.143f5b6f.jpg";